import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Sparkle({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M19.0465 2.4006C19.4401 3.60926 20.3901 4.55933 21.5988 4.95289C21.8021 5.01909 21.8608 5.21344 21.8608 5.33301C21.8608 5.45258 21.8021 5.64693 21.5988 5.71313C20.3901 6.10669 19.4401 7.05676 19.0465 8.26542C18.9803 8.46873 18.786 8.52747 18.6664 8.52747C18.5468 8.52747 18.3525 8.46873 18.2863 8.26542C17.8927 7.05676 16.9426 6.10669 15.734 5.71313C15.5307 5.64693 15.4719 5.45258 15.4719 5.33301C15.4719 5.21344 15.5307 5.01909 15.734 4.95289C16.9426 4.55933 17.8927 3.60926 18.2863 2.4006C18.3525 2.19729 18.5468 2.13855 18.6664 2.13855C18.786 2.13855 18.9803 2.19729 19.0465 2.4006Z"
        fill={iconColor}
      />
      <Path
        d="M11.6433 4.55114C11.5392 4.12837 11.1611 3.96545 10.8887 3.96545C10.6164 3.96545 10.2382 4.12838 10.1342 4.55114C9.18692 8.39999 6.17794 11.409 2.32909 12.3562C1.90633 12.4603 1.74341 12.8384 1.74341 13.1108C1.74341 13.3831 1.90633 13.7613 2.32909 13.8653C6.17794 14.8126 9.18692 17.8216 10.1342 21.6704C10.2382 22.0932 10.6164 22.2561 10.8887 22.2561C11.1611 22.2561 11.5392 22.0932 11.6433 21.6704C12.5905 17.8216 15.5995 14.8126 19.4484 13.8653C19.8711 13.7613 20.0341 13.3831 20.0341 13.1108C20.0341 12.8384 19.8711 12.4603 19.4484 12.3562C15.5995 11.409 12.5905 8.39999 11.6433 4.55114ZM4.30122 13.1108C7.29228 11.8936 9.67156 9.51433 10.8887 6.52327C12.1059 9.51433 14.4852 11.8936 17.4762 13.1108C14.4852 14.328 12.1059 16.7072 10.8887 19.6983C9.67156 16.7072 7.29228 14.328 4.30122 13.1108Z"
        fill={iconColor}
      />
    </Svg>
  );
}
